import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DeleteIcon from "@material-ui/icons/Delete";
import CustomerSearchForm from "../components/customer_search_form";
import CircularProgress from "@material-ui/core/CircularProgress";
import { fetchCustomerMemosCount, deleteCustomerMemos } from "../services/api";
import CustomSnackbar from "../components/custom_snackbar";

const AJAX_TIMEOUT = "timeout";

const styles = (theme) => ({
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(1500 + theme.spacing(3 * 2))]: {
      width: 1500,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  cardGrid: {
    padding: `${theme.spacing(8)}px 0`,
  },
  mainArea: {
    minHeight: theme.spacing(8),
  },
  buttonArea: {
    marginTop: theme.spacing(2),
  },
  innerButtonContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loadingContent: {
    textAlign: "center",
  },
});

class CustomerInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      snackMessage: null,
      branchCode: "",
      accountNumber: "",
      memoCount: null,
      isExecution: false,
      isDeleting: false,
      openDeleteDialog: false,
    };
    this.handleChangeBranchCode = this.handleChangeBranchCode.bind(this);
    this.handleChangeAccountNumber = this.handleChangeAccountNumber.bind(this);
    this.viewErrorSnackBar = this.viewErrorSnackBar.bind(this);
    this.onErrorSnackbarClose = this.onErrorSnackbarClose.bind(this);
    this.viewSuccessSnackBar = this.viewSuccessSnackBar.bind(this);
    this.onSuccessSnackbarClose = this.onSuccessSnackbarClose.bind(this);
    this.clearMemoCount = this.clearMemoCount.bind(this);
    this.handleFetchMemo = this.handleFetchMemo.bind(this);
    this.setOpenDeleteDialog = this.setOpenDeleteDialog.bind(this);
  }

  handleChangeBranchCode = (event) => {
    if (/^([0-9]{0,3})$/.test(event.target.value))
      this.setState({ branchCode: event.target.value });
  };
  handleChangeAccountNumber = (event) => {
    if (/^([0-9]{0,7})$/.test(event.target.value))
      this.setState({ accountNumber: event.target.value });
  };

  viewErrorSnackBar(mes) {
    this.setState({ snackMessage: mes });
  }
  onErrorSnackbarClose() {
    this.setState({ snackMessage: null });
  }

  viewSuccessSnackBar(mes) {
    this.setState({ successMessage: mes });
  }

  onSuccessSnackbarClose() {
    this.setState({ successMessage: null });
  }

  clearMemoCount = () => {
    this.setState({ memoCount: null });
  };

  handleFetchMemo = () => {
    //Validate account number
    if (!this.state.accountNumber) {
      return this.viewErrorSnackBar("口座番号を入力してください。");
    }

    //Validate account branch number and account number
    if (
      /^([a-zA-Z0-9]{0,2})$/.test(this.state.branchCode) ||
      /^([a-zA-Z0-9]{0,6})$/.test(this.state.accountNumber)
    )
      return this.viewErrorSnackBar(
        "店番号は3桁、口座番号は7桁で入力してください。"
      );

    //Validate branch code
    if (
      /^(?!1(01|02|03|04|05|06|07|08|09|10|11|12)).*$/.test(
        this.state.branchCode
      )
    ) {
      return this.viewErrorSnackBar("存在しない店番号が入力されています。");
    }
    this.clearMemoCount();
    this.setState({ isExecution: true });

    fetchCustomerMemosCount(this.state.branchCode, this.state.accountNumber)
      .done((response) => {
        if (response.view_message) {
          this.viewErrorSnackBar(response.view_message);
        } else if (response.error_code) {
          this.viewErrorSnackBar(
            "該当する店番号・口座番号の顧客が見つかりません。"
          );
        }
        this.setState({ memoCount: response.memo_count });
        this.setState({ isExecution: false });
      })
      .fail((jqXHR, status, error) => {
        this.setState({ isExecution: false });
        this.clearMemoCount();
        if (status === AJAX_TIMEOUT) {
          return this.viewErrorSnackBar(
            "要求を処理するための時間が切れました（タイムアウト）。再度やりなおしてください。"
          );
        }
        return this.viewErrorSnackBar(
          "予期せぬエラーが発生しました。再試行してください。"
        );
      });
  };

  clickDeleteMemo = () => {
    this.setState({ openDeleteDialog: false });

    //Validate account number
    if (!this.state.accountNumber) {
      return this.viewErrorSnackBar("口座番号を入力してください。");
    }

    //Validate account branch number and account number
    if (
      /^([a-zA-Z0-9]{0,2})$/.test(this.state.branchCode) ||
      /^([a-zA-Z0-9]{0,6})$/.test(this.state.accountNumber)
    ) {
      return this.viewErrorSnackBar(
        "店番号は3桁、口座番号は7桁で入力してください。"
      );
    }

    //Validate branch code
    if (
      /^(?!1(01|02|03|04|05|06|07|08|09|10|11|12)).*$/.test(
        this.state.branchCode
      )
    ) {
      return this.viewErrorSnackBar("存在しない店番号が入力されています。");
    }
    this.setState({ isDeleting: true });

    deleteCustomerMemos(this.state.branchCode, this.state.accountNumber)
      .done((response) => {
        if (response.view_message) {
          //エラーメッセージを真ん中の画面に出力できるように修正
          this.viewErrorSnackBar(response.view_message);
        } else if (response.error_code) {
          this.viewErrorSnackBar(
            "該当する店番号・口座番号の顧客が見つかりません。"
          );
        }
        this.setState({ memoCount: response.remain_memo_count });
        this.setState({ isDeleting: false });
      })
      .fail((jqXHR, status, error) => {
        if (status === AJAX_TIMEOUT) {
          return this.viewErrorSnackBar(
            "要求を処理するための時間が切れました（タイムアウト）。再度やりなおしてください。"
          );
        }
        return this.viewErrorSnackBar(
          "予期せぬエラーが発生しました。再試行してください。"
        );
      });
  };

  setOpenDeleteDialog = (setOpen) => {
    this.setState({ openDeleteDialog: setOpen });
  };

  componentDidMount() {
    this.props.setSubtitle("長期明細メモ削除画面 ~デジタルバンキング部専用~");
  }

  render() {
    const { classes } = this.props;
    const { snackMessage, successMessage, memoCount, openDeleteDialog } =
      this.state;

    let mainContent;
    if (!this.state.isExecution && !memoCount) {
      mainContent = <p>店番号、口座番号を入力し検索を行なってください。</p>;
    } else if (!this.state.isExecution && memoCount) {
      mainContent = (
        <div>
          削除対象メモ件数: {memoCount}
          <p>
            <small className={classes.captionArea}>
              *だいたい270件ずつの削除になるので約
              {Math.floor((memoCount - 1) / 270 + 1)}回
              ほど実行する必要があります。
            </small>
          </p>
        </div>
      );
    } else if (this.state.isExecution || this.state.isDeleting) {
      mainContent = (
        <div className={classes.loadingContent}>
          <CircularProgress size={40} />
        </div>
      );
    }

    if (memoCount === 0) {
      mainContent = <div>削除対象のメモがありません。</div>;
    }

    let innerButtonContent;
    if (this.state.isDeleting) {
      innerButtonContent = (
        <div className={classes.innerButtonContent}>
          <CircularProgress
            className={classes.loadingButton}
            size={20}
            color="inherit"
          />
        </div>
      );
    } else {
      innerButtonContent = <div>削除</div>;
    }

    return (
      <React.Fragment>
        <main>
          <div className={classNames(classes.layout, classes.cardGrid)}>
            <CustomerSearchForm
              handleFetchInfo={this.handleFetchMemo}
              branchCode={this.state.branchCode}
              accountNumber={this.state.accountNumber}
              handleChangeBranchCode={this.handleChangeBranchCode}
              handleChangeAccountNumber={this.handleChangeAccountNumber}
              hiddenCifNumber={true}
            />

            <div class="row" className={classes.mainArea}>
              {mainContent}
            </div>
            <div class="row" className={classes.buttonArea}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={this.state.isDeleting ? "" : <DeleteIcon />}
                onClick={() => this.setOpenDeleteDialog(true)}
                disabled={
                  !this.state.branchCode ||
                  !this.state.accountNumber ||
                  !memoCount ||
                  this.state.isDeleting
                }
              >
                {innerButtonContent}
              </Button>
              <Dialog
                open={openDeleteDialog}
                onClose={() => this.setOpenDeleteDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"最終確認"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    削除権限の保持者以外の方は削除実行できません
                    <br />
                    1度消すと元に戻すことはできません
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.setOpenDeleteDialog(false)}
                    autoFocus
                  >
                    キャンセル
                  </Button>
                  <Button color="secondary" onClick={this.clickDeleteMemo}>
                    削除
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </main>
        <CustomSnackbar
          snackMessage={snackMessage}
          onSnackbarClose={this.onErrorSnackbarClose}
        />
        <CustomSnackbar
          snackMessage={successMessage}
          onSnackbarClose={this.onSuccessSnackbarClose}
          snackType="SUCCESS"
        />
      </React.Fragment>
    );
  }
}

CustomerInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  setSubtitle: PropTypes.func.isRequired,
};

export default withStyles(styles)(CustomerInfo);
